import { Toaster } from "react-hot-toast";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// styles
import "swiper/css";
import "swiper/css/pagination";
import "styles/swiper.css";
import "styles/global.css";
import "styles/react-calendar.css";

// pages
import Home from "pages/home";
import ExploreDetail from "pages/exploreDetail";
import TopCities from "pages/topCities";
import HotDetail from "pages/hotDetail";
import BookTicket from "pages/bookTickets";

function App() {
  return (
    <div className="w-full min-h-screen">
      <Toaster position="top-center" reverseOrder={false} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/explore/:id" element={<ExploreDetail />} />
          <Route path="/top-cities/:id" element={<TopCities />} />
          <Route path="/ho-detail/:id" element={<HotDetail />} />
          <Route path="/book-tickets" element={<BookTicket />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
